import financeiroApi from './financeiroApi';

const PATH = '/api/v1/backend/nota-fiscal';

const getParams = (params) => {
  let newParams;
  if (params?.filtroAvancado) {
    newParams = { ...params, ...params.filtroAvancado };
    delete newParams.filtroAvancado;
  } else {
    newParams = params;
  }

  return newParams;
};

const notaFiscalApi = {
  buscar: (search) => {
    const url = `${PATH}`;
    return financeiroApi.get(url, { params: getParams(search) });
  },
  somatorio: (search) => {
    const url = `${PATH}/somatorio`;
    return financeiroApi.post(url, null, { params: { ...search } });
  },
  exportarExcel: (search) => {
    const url = `${PATH}/relatorio/excel`;
    return financeiroApi.post(url, null, { params: { ...search } });
  },
  exportarPDF: (uuid) => {
    const url = `${PATH}/exportar-pdf/${uuid}`;
    return financeiroApi.get(url);
  },
  exportarNotaFiscalPDF: (search) => {
    const url = `${PATH}/exportar/zip/pdf`;
    return financeiroApi.post(url, search);
  },
  exportarNotaFiscalIndividualXML: (search) => {
    const url = `${PATH}/exportar/xml`;
    return financeiroApi.post(url, null, { params: { ...search } });
  },
  exportarNotaFiscalXML: (search) => {
    const url = `${PATH}/exportar/zip/xml`;
    return financeiroApi.post(url, null, { params: { ...search } });
  },
};

export default notaFiscalApi;
